const isDebug = false;
const DEBUG_HOST = '192.168.1.100';
const HOST: string = (isDebug)
    ? DEBUG_HOST
    : window.location.hostname;

const KaitenServerPort: number = 5007;

const KaitenServerURL: string = `${HOST}:${KaitenServerPort}`;

export const urlKaitenInfo: string = `https://${KaitenServerURL}/v1/info/`;
